module.exports = __webpack_public_path__ + "img/book3.c5d78050.png";